/* =========================================
   MOBILE NAV TOGGLE
========================================= */
(function(){
  var toggle = document.getElementById('navToggle');
  var nav = document.getElementById('siteNav');
  if (!toggle || !nav) return;

  toggle.addEventListener('click', function(){
    nav.classList.toggle('is-open');
  });

  nav.querySelectorAll('a').forEach(function(link){
    link.addEventListener('click', function(){
      nav.classList.remove('is-open');
    });
  });
})();

/* =========================================
   LANGUAGE SWITCHER (native Shopify localization_form)
   The dropdown is purely a UI toggle — selecting a language submits the
   surrounding {% form 'localization' %} natively, no fetch/AJAX involved.
========================================= */
(function(){
  var switcher = document.querySelector('.lang-switcher');
  if (!switcher) return;

  var toggle = switcher.querySelector('.lang-switcher-toggle');
  if (!toggle) return;

  function close(){
    switcher.classList.remove('is-open');
    toggle.setAttribute('aria-expanded', 'false');
  }

  toggle.addEventListener('click', function(e){
    e.stopPropagation();
    var isOpen = switcher.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  });

  document.addEventListener('click', function(e){
    if (!switcher.contains(e.target)) close();
  });

  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape') close();
  });
})();

/* =========================================
   SCROLL FADE-IN ANIMATIONS
========================================= */
(function(){
  var items = document.querySelectorAll('.fade-up');
  if (!items.length) return;

  var observer = new IntersectionObserver(function(entries){
    entries.forEach(function(entry){
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });

  items.forEach(function(item){ observer.observe(item); });
})();

/* =========================================
   ACCORDION (FAQ + product details)
========================================= */
(function(){
  var questions = document.querySelectorAll('.faq-question');
  if (!questions.length) return;

  questions.forEach(function(btn){
    btn.addEventListener('click', function(){
      var item = btn.closest('.faq-item');
      var list = btn.closest('.faq-list');
      var wasOpen = item.classList.contains('is-open');

      list.querySelectorAll('.faq-item').forEach(function(el){
        el.classList.remove('is-open');
      });

      if (!wasOpen) { item.classList.add('is-open'); }
    });
  });
})();

/* =========================================
   PRODUCT GALLERY (thumbnail switching)
========================================= */
(function(){
  var mainImg = document.getElementById('productMainImage');
  var thumbs = document.querySelectorAll('.product-gallery-thumbs button');
  if (!mainImg || !thumbs.length) return;

  thumbs.forEach(function(thumb){
    thumb.addEventListener('click', function(){
      var newSrc = thumb.getAttribute('data-full');
      var newAlt = thumb.getAttribute('data-alt');

      thumbs.forEach(function(t){ t.classList.remove('is-active'); });
      thumb.classList.add('is-active');

      mainImg.style.opacity = 0;
      setTimeout(function(){
        mainImg.setAttribute('src', newSrc);
        if (newAlt) mainImg.setAttribute('alt', newAlt);
        mainImg.style.opacity = 1;
      }, 150);
    });
  });
})();

/* =========================================
   PRODUCT IMAGE LIGHTBOX (zoom on click/tap)
   Reads the same thumbnail data-full/data-alt attributes the gallery
   above uses, so it always reflects whatever image set is currently on
   the page — including after a variant swap.
========================================= */
(function(){
  var trigger = document.getElementById('ProductGalleryMain');
  var mainImg = document.getElementById('productMainImage');
  var lightbox = document.getElementById('ProductLightbox');
  if (!trigger || !mainImg || !lightbox) return;

  var lightboxImg = document.getElementById('LightboxImage');
  var stage = lightbox.querySelector('.lightbox-stage');
  var closeTargets = lightbox.querySelectorAll('[data-lightbox-close]');
  var prevBtn = lightbox.querySelector('[data-lightbox-prev]');
  var nextBtn = lightbox.querySelector('[data-lightbox-next]');
  var thumbs = document.querySelectorAll('.product-gallery-thumbs button');

  var currentIndex = 0;
  var navEnabled = true;

  function getImages(){
    if (thumbs.length){
      return Array.prototype.map.call(thumbs, function(t){
        return { src: t.getAttribute('data-full'), alt: t.getAttribute('data-alt') || '' };
      });
    }
    return [{ src: mainImg.getAttribute('src'), alt: mainImg.getAttribute('alt') || '' }];
  }

  function findActiveIndex(images){
    var activeSrc = mainImg.getAttribute('src');
    for (var i = 0; i < images.length; i++){
      if (images[i].src === activeSrc) return i;
    }
    return -1;
  }

  function showImage(index, imagesOverride){
    var images = imagesOverride || getImages();
    if (!images.length) return;
    currentIndex = (index + images.length) % images.length;
    var current = images[currentIndex];

    lightboxImg.setAttribute('src', current.src);
    lightboxImg.setAttribute('alt', current.alt);

    navEnabled = images.length > 1;
    if (prevBtn) prevBtn.hidden = !navEnabled;
    if (nextBtn) nextBtn.hidden = !navEnabled;

    /* Keep the underlying gallery/thumbnails in sync, so whatever image
       you land on in the lightbox is still selected once you close it —
       skipped when showing a one-off override image (e.g. a manually set
       main image) that isn't part of the real thumbnail set at all. */
    if (!imagesOverride && thumbs.length && thumbs[currentIndex]){
      thumbs.forEach(function(t){ t.classList.remove('is-active'); });
      thumbs[currentIndex].classList.add('is-active');
      mainImg.setAttribute('src', current.src);
      mainImg.setAttribute('alt', current.alt);
    }
  }

  function openLightbox(){
    var images = getImages();
    var idx = findActiveIndex(images);
    if (idx === -1) {
      /* Whatever's currently displayed (e.g. a manual main-image override)
         doesn't match any real product thumbnail — show it as its own
         single-image lightbox instead of silently jumping to an unrelated
         thumbnail. */
      showImage(0, [{ src: mainImg.getAttribute('src'), alt: mainImg.getAttribute('alt') || '' }]);
    } else {
      showImage(idx);
    }
    lightbox.classList.add('is-open');
    lightbox.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeLightbox(){
    lightbox.classList.remove('is-open');
    lightbox.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  trigger.addEventListener('click', openLightbox);
  trigger.addEventListener('keydown', function(e){
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      openLightbox();
    }
  });

  closeTargets.forEach(function(el){
    el.addEventListener('click', closeLightbox);
  });

  if (prevBtn) prevBtn.addEventListener('click', function(){ showImage(currentIndex - 1); });
  if (nextBtn) nextBtn.addEventListener('click', function(){ showImage(currentIndex + 1); });

  document.addEventListener('keydown', function(e){
    if (!lightbox.classList.contains('is-open')) return;
    if (e.key === 'Escape') closeLightbox();
    if (!navEnabled) return;
    if (e.key === 'ArrowLeft') showImage(currentIndex - 1);
    if (e.key === 'ArrowRight') showImage(currentIndex + 1);
  });

  /* Swipe left/right to navigate on touch devices */
  var touchStartX = null;
  if (stage) {
    stage.addEventListener('touchstart', function(e){
      touchStartX = e.touches[0].clientX;
    }, { passive: true });

    stage.addEventListener('touchend', function(e){
      if (touchStartX === null || !navEnabled) { touchStartX = null; return; }
      var deltaX = e.changedTouches[0].clientX - touchStartX;
      if (Math.abs(deltaX) > 40) {
        if (deltaX < 0) { showImage(currentIndex + 1); } else { showImage(currentIndex - 1); }
      }
      touchStartX = null;
    });
  }
})();

/* =========================================
   QUANTITY SELECTOR
   Handles every .qty-selector on the page (the product page has one; the
   cart page has one per line item), each wired up independently.
========================================= */
(function(){
  var selectors = document.querySelectorAll('.qty-selector');
  if (!selectors.length) return;

  selectors.forEach(function(selector){
    var input = selector.querySelector('input, span');
    var decrease = selector.querySelector('[data-qty-decrease]');
    var increase = selector.querySelector('[data-qty-increase]');
    if (!input || !decrease || !increase) return;

    function getQty(){
      return parseInt(input.value || input.textContent, 10) || 1;
    }

    function setQty(value){
      if (value < 1) value = 1;
      if (input.tagName === 'INPUT') { input.value = value; } else { input.textContent = value; }
    }

    decrease.addEventListener('click', function(){ setQty(getQty() - 1); });
    increase.addEventListener('click', function(){ setQty(getQty() + 1); });
  });
})();

/* =========================================
   CART PAGE — remove line item
   Zeroes the matching quantity input and submits the standard cart form,
   which Shopify treats as a line removal. No AJAX needed for this page.
========================================= */
(function(){
  var removeButtons = document.querySelectorAll('[data-cart-remove]');
  if (!removeButtons.length) return;

  removeButtons.forEach(function(btn){
    btn.addEventListener('click', function(){
      var line = btn.getAttribute('data-line');
      var input = document.querySelector('input[name="updates[]"][data-line="' + line + '"]');
      if (input) input.value = 0;

      var form = btn.closest('form');
      if (form) form.submit();
    });
  });
})();

/* =========================================
   PRODUCT VARIANT PICKER (dynamic Shopify product)
   Reads the serialized variants JSON rendered by
   sections/main-product.liquid and keeps the hidden
   variant id input, price, image and swatch labels in sync.
========================================= */
(function(){
  var dataScript = document.querySelector('script[data-product-variants]');
  var form = document.getElementById('ProductForm');
  if (!dataScript || !form) return;

  var variants;
  try {
    variants = JSON.parse(dataScript.textContent);
  } catch (e) {
    return;
  }

  var variantIdInput = document.getElementById('ProductVariantId');
  var priceEl = document.getElementById('ProductPrice');
  var comparePriceEl = document.getElementById('ProductComparePrice');
  var mainImg = document.getElementById('productMainImage');
  var submitBtn = document.getElementById('ProductSubmitButton');
  var thumbs = document.querySelectorAll('.product-gallery-thumbs button');
  var optionGroups = document.querySelectorAll('.variant-swatches[data-option-index]');

  var selectedOptions = [];
  optionGroups.forEach(function(group){
    var activeSwatch = group.querySelector('.variant-swatch.is-active') || group.querySelector('.variant-swatch');
    var index = parseInt(group.getAttribute('data-option-index'), 10);
    if (activeSwatch) selectedOptions[index] = activeSwatch.getAttribute('data-value');
  });

  function findMatchingVariant(){
    return variants.filter(function(variant){
      return variant.options.every(function(value, i){ return value === selectedOptions[i]; });
    })[0];
  }

  function applyVariant(variant){
    if (!variant) return;

    if (variantIdInput) variantIdInput.value = variant.id;

    if (priceEl) priceEl.textContent = variant.price;
    if (comparePriceEl) {
      if (variant.compare_at_price) {
        comparePriceEl.textContent = variant.compare_at_price;
        comparePriceEl.style.display = '';
      } else {
        comparePriceEl.style.display = 'none';
      }
    }

    if (submitBtn) {
      if (variant.available) {
        submitBtn.disabled = false;
        submitBtn.textContent = submitBtn.getAttribute('data-available-text') || submitBtn.textContent;
      } else {
        submitBtn.disabled = true;
        submitBtn.textContent = submitBtn.getAttribute('data-sold-out-text') || submitBtn.textContent;
      }
    }

    if (variant.image && mainImg) {
      mainImg.style.opacity = 0;
      setTimeout(function(){
        mainImg.setAttribute('src', variant.image);
        mainImg.setAttribute('alt', variant.image_alt || '');
        mainImg.style.opacity = 1;
      }, 150);

      thumbs.forEach(function(t){ t.classList.remove('is-active'); });
      var matchingThumb = document.querySelector('.product-gallery-thumbs button[data-full="' + variant.image + '"]');
      if (matchingThumb) matchingThumb.classList.add('is-active');
    }
  }

  optionGroups.forEach(function(group){
    var index = parseInt(group.getAttribute('data-option-index'), 10);

    group.querySelectorAll('.variant-swatch').forEach(function(swatch){
      swatch.addEventListener('click', function(){
        group.querySelectorAll('.variant-swatch').forEach(function(s){ s.classList.remove('is-active'); });
        swatch.classList.add('is-active');

        selectedOptions[index] = swatch.getAttribute('data-value');

        var label = group.closest('.product-option-group').querySelector('.selected-value');
        if (label) label.textContent = selectedOptions[index];

        applyVariant(findMatchingVariant());
      });
    });
  });
})();

/* =========================================
   CART COUNT (Shopify native cart object + AJAX Cart API)
   Keeps the header cart bubble in sync without a page reload. Exposed on
   window so the add-to-cart handler below can call it after a successful add.
========================================= */
(function(){
  if (!window.routes || !window.routes.cartUrl) return;

  window.CuddleBellyUpdateCartCount = function(){
    fetch(window.routes.cartUrl + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function(response){ return response.json(); })
      .then(function(cart){
        document.querySelectorAll('#CartCount').forEach(function(el){
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
      })
      .catch(function(){});
  };

  // Refresh the count when returning via the back/forward cache, since the
  // cart may have changed on a page visited in between.
  window.addEventListener('pageshow', function(event){
    if (event.persisted) window.CuddleBellyUpdateCartCount();
  });
})();

/* =========================================
   ADD TO CART (Shopify AJAX Cart API)
   Progressive enhancement: if this script fails to run, the surrounding
   {% form 'product' %} still submits normally and adds the item to the cart.
========================================= */
(function(){
  var form = document.getElementById('ProductForm');
  if (!form || !window.routes || !window.routes.cartAddUrl) return;

  var note = form.querySelector('.add-to-cart-note');
  var submitBtn = document.getElementById('ProductSubmitButton');

  form.addEventListener('submit', function(e){
    e.preventDefault();

    var formData = new FormData(form);

    if (submitBtn) submitBtn.disabled = true;
    if (note) note.textContent = 'Adding to your cart…';

    fetch(window.routes.cartAddUrl + '.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: formData
    })
      .then(function(response){ return response.json().then(function(data){ return { ok: response.ok, data: data }; }); })
      .then(function(result){
        if (submitBtn) submitBtn.disabled = false;
        if (result.ok) {
          if (note) note.textContent = 'Added to your cart.';
          if (window.CuddleBellyUpdateCartCount) window.CuddleBellyUpdateCartCount();
        } else {
          if (note) note.textContent = (result.data && result.data.description) || 'Something went wrong — please try again.';
        }
      })
      .catch(function(){
        if (submitBtn) submitBtn.disabled = false;
        if (note) note.textContent = 'Something went wrong — please try again.';
      });
  });
})();
